/** 套餐主题色 */
export const PLAN_THEMES = [
    {
        themeKey: 'standard',
        cardGradient: 'linear-gradient(180deg, #d4f5e4 0%, #ecfbf3 35%, #ffffff 72%)',
        color: '#2dcb8d',
        compareHeaderBg: '#e6f4ea'
    },
    {
        themeKey: 'advanced',
        cardGradient: 'linear-gradient(180deg, #ffe5d4 0%, #fff3eb 35%, #ffffff 72%)',
        color: '#ff643d',
        compareHeaderBg: '#fce8e6'
    },
    {
        themeKey: 'professional',
        cardGradient: 'linear-gradient(180deg, #ede8ff 0%, #f5f2ff 35%, #ffffff 72%)',
        color: '#9266ff',
        compareHeaderBg: '#f3e5f5'
    },
    {
        themeKey: 'supreme',
        cardGradient: 'linear-gradient(180deg, #e0eaff 0%, #eef2ff 35%, #ffffff 72%)',
        color: '#3d66e4',
        compareHeaderBg: '#e8eaf6'
    }
]

export function getCompareTitle(isCA) {
    // return isCA ? 'CA版本套餐介绍' : '版本套餐介绍'
    return isCA ? '版本套餐介绍' : '版本套餐介绍'
}
